// @flow strict
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SiteSidebar from '../components/SiteSidebar';
import PhotographFeed from '../components/PhotographFeed';
import Page from '../components/Page';
import Pagination from '../components/Pagination';
import { useSiteMetadata } from '../hooks';
import type { PageContext, AllMarkdownRemark } from '../types';

type Props = {
    data: AllMarkdownRemark,
    pageContext: PageContext
};

const PhotographsIndexTemplate = ({ data, pageContext }: Props) => {
    const { title: siteTitle, subtitle: siteSubtitle } = useSiteMetadata();

    const {
        currentPage,
        hasNextPage,
        hasPrevPage,
        prevPagePath,
        nextPagePath
    } = pageContext;

    const { edges } = data.allMarkdownRemark;
    const pageTitle = currentPage > 0 ? `Photographs - Page ${currentPage} - ${siteTitle}` : `Photographs - ${siteTitle}`;

    return (
        <Layout title={pageTitle} description={siteSubtitle}>
            <SiteSidebar layout="page" />
            <Page>
                <PhotographFeed edges={edges} />
                {(hasPrevPage || hasNextPage) && (
                    <Pagination
                        prevPagePath={prevPagePath}
                        nextPagePath={nextPagePath}
                        hasPrevPage={hasPrevPage}
                        hasNextPage={hasNextPage}
                    />
                )}
            </Page>
        </Layout>
    );
};

export const query = graphql`
  query PhotographsIndexTemplate($postsLimit: Int!, $postsOffset: Int!) {
    allMarkdownRemark(
        limit: $postsLimit,
        skip: $postsOffset,
        filter: { frontmatter: { template: { eq: "post" }, photograph: { eq: true }, draft: { ne: true } } },
        sort: { order: DESC, fields: [frontmatter___date] }
      ){
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date
            photographImage
            caption
          }
        }
      }
    }
  }
`;

export default PhotographsIndexTemplate;
